import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import StarField from './StarField';


function Bhole() {
  const { t } = useTranslation();

  return (
    <div>
        <StarField numStars={150} speed={0.1} />

        <Link to="/">{t('bhole.startOver')}</Link>
    </div>
  );
}

export default Bhole;
